export class Reporter {
    constructor(config) {
        this.onError = config.onError;
        this.disabled = config.disabled ?? false;
    }
}
//# sourceMappingURL=Reporter.js.map